import passwordIcon from "./passwordIcon.png";
import userIcon from "./userIcon.png";
import arrowLeft from "./arrowLeft.svg";
import arrowRight from "./arrowRight.svg";
import arrowDown from "./arrowDown.svg";
import availableCash from "./availableCash.svg";
import awaitingPayment from "./awaitingPayment.svg";
import calendar from "./calendar.svg";
import dashboardActive from "./dashboardActive.svg";
import notSubmitted from "./notSubmitted.svg";
import pettyCash from "./pettyCash.svg";
import reconciliation from "./reconciliation.svg";
import reports from "./reports.svg";
import vouchers from "./vouchers.svg";
import bellIcon from "./bellIcon.svg";
import backIcon from "./backIcon.svg";
import plusIcon from "./plusIcon.svg";
import plusBlackIcon from "./plusBlackIcon.svg";
import searchIcon from "./searchIcon.svg";
import trashIcon from "./trashIcon.svg";
import circlePlusIcon from "./circlePlus.svg";
import loopIcon from "./loopIcon.svg";
import laptopIcon from "./laptopIcon.svg";
import mobileIcon from "./mobileIcon.svg";
import removeCircleIcon from "./removeCircleIcon.svg";
import faqIcon from "./faqIcon.svg";
import newIcon from "./newIcon.svg";
import sendMailIcon from "./sendMailIcon.svg";
import requestIcon from "./requestIcon.svg";
import helpIcon from "./helpIcon.svg";
import editPhotoIcon from "./editPhotoIcon.svg";
import helpIcon2 from "./helpIcon2.svg";
import assignIcon from "./assignIcon.svg";
import accountIcon from "./accountIcon.svg";
import signoutIcon from "./signoutIcon.svg";
import raiseIcon from "./raiseIcon.svg";
import calendarIcon from "./calendarIcon.svg";
import attachmentIcon from "./attachmentIcon.svg";
import editIcon from "./editIcon.svg";
import groupIcon from "./groupIcon.svg";
import roleIcon from "./roleIcon.svg";
import uploadConfigIcon from "./ico-upload-file.svg"
import cashDepositeIcon from "./cash-deposit.svg"

export const icons = {
  passwordIcon,
  userIcon,
  arrowLeft,
  arrowRight,
  arrowDown,
  availableCash,
  awaitingPayment,
  calendar,
  dashboardActive,
  notSubmitted,
  pettyCash,
  reconciliation,
  reports,
  vouchers,
  backIcon,
  bellIcon,
  plusIcon,
  plusBlackIcon,
  searchIcon,
  trashIcon,
  circlePlusIcon,
  loopIcon,
  laptopIcon,
  mobileIcon,
  removeCircleIcon,
  faqIcon,
  newIcon,
  sendMailIcon,
  requestIcon,
  helpIcon,
  editPhotoIcon,
  helpIcon2,
  assignIcon,
  accountIcon,
  signoutIcon,
  raiseIcon,
  calendarIcon,
  attachmentIcon,
  editIcon,
  groupIcon,
  roleIcon,
  uploadConfigIcon,
  cashDepositeIcon
};
